import revenueImg from "../../../assets/images/service/revenue.png";
import {
  FileSearch,
  Map,
  Landmark,
  FileCheck,
  TrendingUp,
  Maximize,
  UserCheck,
  History,
  Stamp,
  Globe2
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function RevenueMatters() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Expertise in <span className="green">Revenue & Land</span> Records
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise provides comprehensive advisory for land revenue matters, 
                    ensuring clear titles, accurate boundary marking, and seamless 
                    Non-Agricultural (NA) conversions for industrial projects.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Title clearance & 7/12 (Sat-bara) record verification</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Nagar Niyojan (Town Planning) compliance & zoning</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Liaison with Mamlatdar, Collector & Revenue Departments</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={revenueImg}
                      alt="Revenue and Land Record Advisory"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-map-marked-alt"></i> Verified Land Titles
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">Securing the Foundation of Your Project</h3>
                    <p className="mb-3">
                      The success of any utility project, from a 66kV substation to a CNG hub, begins with flawless land records. We specialize in deep-dive title searches, resolving historical discrepancies in revenue entries, and ensuring your land is fully compliant with the "Nagar Niyojan" (Town Planning) schemes of Gujarat.
                    </p>
                    <p className="mb-3">
                      We manage the entire lifecycle of revenue documentation—from obtaining 6-A mutation entries to handling the complex process of NA (Non-Agricultural) conversion and Stamp Duty adjudications, protecting your investment from future legal challenges.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <History size={22} />
                        </span>
                        <span>Historical Title Search & Pedigree (Vanshavali) Verification</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Map size={22} />
                        </span>
                        <span>Boundary Disputes & Measurement (Mojni) Coordination</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Stamp size={22} />
                        </span>
                        <span>Stamp Duty Calculation & Registered Lease Advisory</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileSearch size={22} />
                        </span>
                        <span>Public Notice Management & Title Clearance Certificates</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">Reliability for High-Value Assets</h4>
                    <p className="mb-6">
                      By securing your land revenue status, we eliminate the primary source of project delays, ensuring that your banking and financial tie-ups proceed without hitches.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <Landmark size={22} />
                        </span>
                        <span>Seamless liaison with Gujarat Revenue Authorities</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Globe2 size={22} />
                        </span>
                        <span>Accuracy in zoning and Town Planning compliance</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Fast-tracked NA (Non-Agricultural) permissions</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Increased land value through legalized industrial status</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Mitigation of future land-claim litigation</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Personalized advisory for family and ancestral land</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}